// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__Dp26W","donut-spin":"styles_donut-spin__Owodl"};